import { pluralithAuth } from '@/firebase/firebase'
import store from '@/store'
import { isEmpty } from 'lodash'
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/auth',
    name: 'auth',
    component: () => import(/* webpackChunkName: "auth" */ '../views/Auth.vue')
  },
  {
    path: '/',
    name: 'providers',
    component: () => import(/* webpackChunkName: "overview" */ '../views/Overview.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/:provider',
    name: 'resources',
    component: () => import(/* webpackChunkName: "provider" */ '../views/Provider.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '/:provider/:resource',
        name: 'resources',
        component: () => import(/* webpackChunkName: "provider" */ '../views/Provider.vue'),
        meta: { requiresAuth: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach(async (to, _, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)

  // Checking if user authenticated
  if (requiresAuth && !pluralithAuth.currentUser && to.name !== 'auth') {
    next({ path: '/auth', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

export default router
